import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { ApiBaseUrls, ApiControllers } from "../../constants/constants";
import { ServiceResultModel } from "../../models/service/service-result.model";
import { ServiceUtilities } from "../../utilities/service.utilities";
import { APISanitizerUtilities } from "../../utilities/api-sanitizer.utilities";
import { CreateSupportTicketRequest } from "../../models/data/support-ticket.model";

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  // Support tickets are handled by the Core API's Support controller, which enqueues the outbound email
  // on the Service Bus (same delivery path as the mass-email blast).
  private apiPath: string = `${ApiBaseUrls.CORE()}${ApiControllers.SUPPORT()}`;

  constructor(private httpClient: HttpClient) { }

  public async submitSupportTicket(request: CreateSupportTicketRequest): Promise<ServiceResultModel<void>> {
    try {
      const requestUrl = `${this.apiPath}/tickets`;

      const response = await firstValueFrom(
        this.httpClient.post<void>(
          requestUrl,
          JSON.stringify(APISanitizerUtilities.sanitizePayload<CreateSupportTicketRequest>(request)),
          { observe: "response", headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
        ));

      return <ServiceResultModel>{ success: true, statusCode: response.status };
    } catch (error: any) {
      return ServiceUtilities.handleServiceException(error);
    }
  }
}
